<soft-ds-file-view
  class="soft-document-preview__frame"
  data-testid="document-preview-frame"
  reloadable
  mimeType="application/pdf"
  [file]="document()"
  [loading]="loading()"
  [fileName]="fileName()"
  [emptyText]="'#WWS_DOCUMENTS.PREVIEW.EMPTY' | translate"
  (reload)="reload.emit()"
/>
